<template>
    <add-to-cart-button 
    v-if="product" 
    :data="{
        class: 'btn-primary',
        stockCode: product.stockCode,
        netSuiteId: product.netSuiteId,
        netSuiteParentId: product.netSuiteParentId,
        productId: product.productId,
        quantity: product.quantity,
        hideCartButton: product.hideCartButton,
        isAlwaysInStock: product.isAlwaysInStock,
    }"
    :items="product.components"
    :netsuite_url="netsuite_url"
    :netsuite_app_url="netsuite_app_url">
    </add-to-cart-button>
</template>
<script>
import addToCartButton from "./add-to-cart-standalone.vue";

export default {
  components: { addToCartButton },
    props: ['stockcode','netsuite_url', 'netsuite_app_url'],
    data() {
    return {
      items: [],
      product: null,
    };
  },
    mounted() {
    let baseUrl = "api/products";
    let products = [];
    products.push(this.stockcode);

    let startsWith = function (wordToCompare) {
        return function (element) {
            return element.indexOf(wordToCompare) === 0;
        };
    }

    axios
      .post(`${baseUrl}`, { products: products })
      .then((response) => {
        this.items = response.data.data;

        for (var i = 0; i < this.items.length; i++) {
          this.items[i].quantity = products.filter(
            startsWith(this.items[i].stockCode)
          ).length;
        }

        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].components.length) {
            for (var j = 0; j < this.items[i].components.length; j++) {
              Vue.set(
                this.items[i].components[j],
                "quantity",
                this.items[i].components[j].quantity * this.items[i].quantity
              );
            }
          }
        }
        this.product = this.items[0];
      })
      .catch((error) => {
        console.error("Error: ", error);
      });
    }
}
</script>